import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ECG from "../Assets/Facultiy/ECG.JPG";
import GenralWard from "../Assets/Facultiy/GenralWard.JPG";
import IMG9129 from "../Assets/Facultiy/IMG_9129.JPG";
import IMG9135 from "../Assets/Facultiy/IMG_9135.JPG";
import IMG9226 from "../Assets/Facultiy/IMG_9226.JPG";
import IMG9873 from "../Assets/Facultiy/IMG_9873.JPG";
import IMG9882 from "../Assets/Facultiy/IMG_9882.JPG";
import IMG9913 from "../Assets/Facultiy/IMG_9913.JPG";
import IMG9928 from "../Assets/Facultiy/IMG_9928.JPG";
import Lab from "../Assets/Facultiy/Lab.JPG";
import Pharama from "../Assets/Facultiy/Pharama.JPG";
import phygiyo from "../Assets/Facultiy/phygiyo.JPG";
import "../Styles/Gallery.css";

function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [loadedImages, setLoadedImages] = useState({});

  const galleryItems = [
    {
      id: 1,
      category: "facilities",
      title: "ECG Facility",
      image: ECG,
      description: "Advanced electrocardiography equipment for cardiac monitoring"
    },
    {
      id: 2,
      category: "facilities",
      title: "General Ward",
      image: GenralWard,
      description: "Comfortable and well-equipped general ward for patient care"
    },
    {
      id: 3,
      category: "facilities",
      title: "Medical Facility 3",
      image: IMG9129,
      description: "Advanced medical care facility with modern amenities"
    },
    {
      id: 6,
      category: "facilities",
      title: "Medical Facility 4",
      image: IMG9135,
      description: "Comprehensive medical treatment center"
    },
    {
      id: 7,
      category: "facilities",
      title: "Medical Facility 5",
      image: IMG9226,
      description: "Modern healthcare facility for patient treatment"
    },
    {
      id: 8,
      category: "facilities",
      title: "Laboratory",
      image: Lab,
      description: "Advanced diagnostic laboratory for medical testing"
    },
    {
      id: 9,
      category: "facilities",
      title: "Pharmacy",
      image: Pharama,
      description: "Well-stocked pharmacy with comprehensive medication services"
    },
    {
      id: 10,
      category: "facilities",
      title: "Physiotherapy",
      image: phygiyo,
      description: "Advanced physiotherapy and rehabilitation center"
    },
    {
      id: 11,
      category: "facilities",
      title: "Faculty Image 3",
      image: IMG9873,
      description: ""
    },
    {
      id: 14,
      category: "facilities",
      title: "Faculty Image 4",
      image: IMG9882,
      description: ""
    },
    {
      id: 15,
      category: "facilities",
      title: "Faculty Image 5",
      image: IMG9913,
      description: ""
    },
    {
      id: 16,
      category: "facilities",
      title: "Faculty Image 6",
      image: IMG9928,
      description: ""
    }
  ];

  const categories = [
    { id: "all", label: "All" },
    { id: "facilities", label: "Facilities" }
  ];

  const filteredItems = selectedCategory === "all"
    ? galleryItems
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <>
      <Navbar />
      <div className="gallery-section">
        <div className="gallery-hero">
          <h1 className="gallery-title">Our Gallery</h1>
          <p className="gallery-subtitle">
            Explore our state-of-the-art facilities, dedicated medical team, and advanced treatment procedures
          </p>
        </div>

        <div className="gallery-container">
          {/* Category Filter */}
          <div className="gallery-filters">
            {categories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="gallery-grid">
            {filteredItems.map(item => (
              <div key={item.id} className="gallery-item">
                <div className="gallery-image-container">
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`gallery-image ${loadedImages[item.id] ? 'loaded' : 'loading'}`}
                    loading="lazy"
                    decoding="async"
                    onLoad={() => setLoadedImages((prev) => ({ ...prev, [item.id]: true }))}
                    onError={(e) => {
                      e.target.src = '/images/placeholder.jpg';
                      setLoadedImages((prev) => ({ ...prev, [item.id]: true }));
                    }}
                  />
                  <div className="gallery-overlay">
                    <h3 className="gallery-item-title">{item.title}</h3>
                    <p className="gallery-item-description">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Gallery;
